<!-- 首页底部 -->
<template>
  <div class="home-bottom">
    <ul>
      <li v-for="(item,index) in menuList"
          :key="index">
        <router-link :to="item.path">{{item.name}}</router-link>
      </li>
    </ul>
    <div class="home-bottom-copy" v-html="copyright"></div>
  </div>
</template>

<script>
// less
import './home.less'
import { copyright } from '@/constant'
export default {
  name: 'home-bottom',
  components: {},
  data () {
    return {
      copyright,
      menuList: [
        {
          name: 'Referral',
          path: '/referral'
        },
        // {
        //   name: 'Service',
        //   path: '/torch'
        // },
        // {
        //   name: 'Contact us',
        //   path: '/contact'
        // },
        {
          name: 'WeChat',
          path: '/wechat'
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
